import React from "react";
import "./Products.scss";
// import enginePd from "../../../assets/engineering-pd.png";
// import marinePd from "../../../assets/marine-pd.png";
// import motorPd from "../../../assets/motor-pd.png";
// import propertyPd from "../../../assets/property-pd.png";
// import otherPd from "../../../assets/others-pd.png";
import enginePd from "../../../assets/productImage/eng-pd.png";
import marinePd from "../../../assets/productImage/marine-pd.png";
import motorPd from "../../../assets/productImage/motor-pd.png";
import propertyPd from "../../../assets/productImage/prop-pd.png";
import otherPd from "../../../assets/productImage/misc-pd.png";
import { Link } from "react-router-dom";

const Products = () => {
  return (
    <>
      <div className="products">
        <div className="product_content">
          <div className="container">
            <h2 data-aos="zoom-out-right">OUR PRODUCTS</h2>
            <hr />
            <div className="product_details" data-aos="zoom-out-up">
              <div className="row justify-content-center">
                <div className="col-lg-4">
                  <div className="product_details_card">
                    <img src={enginePd} alt="" className="img-fluid" />
                    <div className="p-4 product_card_text">
                      <h3>ENGINEERING INSURANCES</h3>
                      <p>
                        Engineering insurance refers to the insurance that
                        provides economic safeguard to the risks faced by the
                        ongoing construction project, installation project, and
                        machines and equipment in project operation.
                      </p>
                      <div className="text-center">
                        <Link
                          to="/engineering-insurance"
                          className="btn main_btn"
                        >
                          <span className="btn_text">View Details</span>
                        </Link>
                      </div>{" "}
                    </div>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="product_details_card">
                    <img src={marinePd} alt="" className="img-fluid" />
                    <div className="p-4 product_card_text">
                      <h3>MARINE INSURANCES</h3>
                      <p>
                        Marine insurance covers the loss or damage of ships,
                        cargo, terminals, and any transport by which the
                        property is transferred, acquired, or held between the
                        points of origin and the final destination
                      </p>
                      <div className="text-center">
                        <Link to="/marine-insurance" className="btn main_btn">
                          <span className="btn_text">View Details</span>
                        </Link>{" "}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="product_details_card">
                    <img src={motorPd} alt="" className="img-fluid" />
                    <div className="p-4 product_card_text">
                      <h3>MOTOR INSURANCES</h3>
                      <p>
                        {/* Marine insurance covers the loss or damage of ships,
                        cargo, terminals, and any transport by which the
                        property is transferred, acquired, or held between the
                        points of origin and the final destination
                        <br /> */}
                        A motor insurance policy is a mandatory policy issued by
                        an insurance company as part of prevention of public
                        liability to protect the general public from any
                        accident that might take place on the road.
                      </p>

                      <div className="text-center">
                        <Link to="/motor-insurance" className="btn main_btn">
                          <span className="btn_text">View Details</span>
                        </Link>{" "}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="product_details_card">
                    <img src={propertyPd} alt="" className="img-fluid" />
                    <div className="p-4 product_card_text">
                      <h3>FIRE INSURANCES</h3>
                      <p>
                        Fire insurance is a form of property insurance that
                        covers damage and losses caused by fire. <br /> <br />
                        Damage caused by a fire set deliberately is typically
                        not covered.
                      </p>
                      <Link to="/fire-insurance" className="btn main_btn">
                        <span className="btn_text">View Details</span>
                      </Link>{" "}
                    </div>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="product_details_card">
                    <img src={otherPd} alt="" className="img-fluid" />
                    <div className="p-4 product_card_text">
                      <h3>MISCELLANEOUS INSURANCES</h3>
                      <p>
                        Miscellaneous Insurance refers to contracts of insurance
                        other than those of Life, Fire and Marine insurance.
                        <br />
                        It covers a variety of risks, the chief of which are:-
                        Personal Accident insurance.
                      </p>
                      <Link
                        to="/miscellaneous-insurance"
                        className="btn main_btn"
                      >
                        <span className="btn_text">View Details</span>
                      </Link>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;
